import { Box, Grid, MenuItem, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiClient, ADMIN_SERVER_BASE_URL } from "../util/apiClient";
import {
  addModeleRapport,
  IModeleRapport,
  IPlanItem,
  ITypePlanRapportItem,
  ITypographie,
  // setHideListeModele,
  updateModeleRapport,
} from "../store/modeleRapportSlice";
import { IReduxState } from "../store";
import { ajvValidator, errorNotify } from "../util/functions";
import IconButton from "@mui/material/IconButton";
import AddIcon from '@mui/icons-material/Add';
import Divider from "@mui/material/Divider";
import DeleteIcon from '@mui/icons-material/Delete';
import { Autocomplete } from "@mui/lab";


export interface ITypesPlanItem {
  idType: ITypePlanRapportItem;
  libelle: string;
}

const types: ITypesPlanItem[] = [
  { idType: "textarea", libelle: "Zone de texte multiligne" },
  { idType: "p", libelle: "Paragraphe" },
  { idType: "array", libelle: "Tableau" },
  { idType: "input", libelle: "Zone de texte monoligne" },
  { idType: "radio", libelle: "Case d'option (radio)" },
  { idType: "checkBox", libelle: "Case à cocher (checkbox)" },
  { idType: "comboBox", libelle: "Choix d'element dans une liste" },
];

export interface ITypographiePlanItem {
  idTypographie: ITypographie;
  libelle: string;
}

const typographies: ITypographiePlanItem[] = [
  { idTypographie: "h5", libelle: "Titre niveau 1" },
  { idTypographie: "h6", libelle: "Titre niveau 2" },
  { idTypographie: "subtitle1", libelle: "Titre niveau 3" },
  { idTypographie: "subtitle2", libelle: "Titre niveau 4" },
  { idTypographie: "body1", libelle: "Corp du text 1" },
  { idTypographie: "body2", libelle: "Corp du text 2" },
];

export interface IAddPlanModeleProps {
  planRapport: IPlanItem[];
  setPlanRapport: any;
  currentModele: any;
  setCurrentModele: any;
  planItem: any;
  setPlanItem: any;
  mode: string;
  setMode: any;
  setDisableSaveButton: any;
}

export interface IOptionData {
  idOption: number;
  libelleOption: string;
}

const initialPlanRapport: IPlanItem = {
  index: 0,
  title: "",
  name: "",
  type: "",
  content: "",
  instructions: "",
  typographie: "",
  isChecked: false
};

export default function AddPlanModele(props: IAddPlanModeleProps) {
  //props
  const {
    planRapport,
    setPlanRapport,
    currentModele,
    setCurrentModele,
    planItem,
    setPlanItem,
    mode,
    setMode,
    setDisableSaveButton,
  } = props;

  // console.log("🚀 ~ file: AddPlanModele.tsx:91 ~ AddPlanModele ~ currentModele:", currentModele)

  //redux
  const dispatch = useDispatch();
  const { modelesRapport } = useSelector(
    (state: IReduxState) => state.modeleRapport
  );

  const [index, setIndex] = useState(0);
  const [optionsData, setOptionsData] = useState(planItem ? planItem.optionsData : [{ idOption: 0, libelleOption: "" }]);
    
  

  const onAddOptionRow = () => {
    setOptionsData(optionsData.concat({ idOption: optionsData.length, libelleOption: "" }));
  };

  const handleOptionRowDelete = (idOption: number) => {
    const res = optionsData.filter((item: IOptionData) => item.idOption !== idOption)
    setOptionsData(res);
  };

  const handleOptionInputChange = (e: any, index: number) => {
    let newData = [...optionsData]
    const { value } = e.target
    let obj = newData[index]
    obj = { ...obj, libelleOption: value }
    newData[index] = obj
    setOptionsData(newData)
  }

  // const handleChange = (e: any, index: number) => {
  //   let newData = [...stateRubriqueOptionnelles]
  //   const { value } = e.target
  //   let obj = newData[index]
  //   obj = { ...obj, montantAverser: parseInt(value) }
  //   newData[index] = obj
  //   let totalVal: number = 0
  //   newData.map((item: IRubriquesOptionnelles) => {
  //     if (item.montantAverser) {
  //     return  totalVal += item.montantAverser
  //     }
  //   })

  //   setTotalMontantOptionnel(totalVal)
  //   setStateRubriqueOptionnelles(newData)
  // }

  const renderInputOption = (planItem: IPlanItem) => {
    if (planItem?.type === "checkBox" || planItem?.type === "comboBox" || planItem?.type === "radio") return true
  }

  const handleInputChange = (e: any) => {
    const { value, name } = e.target;
    if (!planItem) return;
    setPlanItem({ ...planItem, [name]: value });
  };

  //ajouter une nouvelle section au plan du rapport

  // validateur
  const validatorPropertiePlanItem = {
    // index: {
    //   type: "number",
    //   nullable: true,
    //   minLength: 0,
    // },
    title: {
      type: "string",
      nullable: false,
      minLength: 1,
      errorMessage: { minLength: "Veuillez remplir le champ titre." },
    },

    name: {
      type: "string",
      nullable: false,
      minLength: 1,
      errorMessage: { minLength: "Veuillez remplir le champ name." },
    },

    type: {
      type: "string",
      nullable: false,
      minLength: 1,
      errorMessage: { minLength: "Veuillez remplir le champ type." },
    },

    // content: {
    //   type: 'string',
    //   nullable: true,
    //   minLength: 1,
    // },

    typographie: {
      type: "string",
      nullable: false,
      minLength: 1,
      errorMessage: { minLength: "Veuillez remplir le champ typograghy." },
    },
  };

  const validatorPlanItem = (data: any) => {
    const schema = {
      type: "object",
      properties: validatorPropertiePlanItem,
      required: ["title", "name", "type", "typographie"],
      errorMessage: {
        type: "Des champs sont vides",
        required: {
          title: "Veuillez remplir ce champ titre.",
          name: "Veuillez remplir le champ name.",
          type: "Veuillez remplir le champ type.",
          typographie: "Veuillez remplir le champ typograghy.",
        },
      },
    };
    return ajvValidator(schema, data);
  };

  const handleAddItem = () => {
    const ajvRes: any = validatorPlanItem(planItem);
    if (ajvRes?.status === 1) {
      if (!planItem) return;
      const newPlanItem = { ...planItem, optionsData: optionsData }
      setPlanRapport([...planRapport, newPlanItem]);
      setDisableSaveButton(false);
      // setOptionsData([{ idOption: 0, libelleOption: "" }])
    } else {
      ajvRes?.errors.length > 0 && errorNotify(ajvRes.errors[0].message);
    }
  };

  //modifier une section du plan du rapport
  const handleEditItem = () => {
    if (!planItem) return;
    const newPlanRapport = planRapport.map((section) =>
      section.index === planItem?.index ? planItem : section
    );
    setPlanRapport(newPlanRapport);
    setMode("add");
    // setOptionsData([{ idOption: 0, libelleOption: "" }])
    setDisableSaveButton(false);
  };

  //obtenir le plan du rapport selectionné
  useEffect(() => {
    const modele = modelesRapport.find(
      (item) => item.idModeleRapport === currentModele?.idModele
    );
    if (modele) {
      setPlanRapport(modele.planModeleRapport);
    }
    // dispatch(setHideListeModele(false));
  }, [currentModele]);

  /**
   * Obtenir l'index du dernier element du tableau
   * puis mettre à jour la variable planItem
   *  */
  useEffect(() => {
    setIndex(planRapport?.length + 1);
    setPlanItem({ ...initialPlanRapport, index: planRapport?.length + 1 });
  }, [planRapport]);

  return (
    <div style={{ backgroundColor: "#ECF0F3", padding: 20 }}>
      <Grid container spacing={3}>
        <Grid item md={12} xs={12} sm={12}>


          <Autocomplete
            fullWidth
            onChange={(e: any, modeleItem) => {
              if (modeleItem) {
                setCurrentModele({
                  ...currentModele,
                  idModele: modeleItem.idModeleRapport
                });
              }
            }}
            options={modelesRapport}
            renderOption={(props, modeleItem) => {
              const { libelleModeleRapport, idModeleRapport } = modeleItem;
              const newIndex = modelesRapport.findIndex(item => item.idModeleRapport === idModeleRapport)
              return (
                <span {...props}
                  style={{ backgroundColor: (newIndex % 2 === 0) ? "aliceblue" : "", fontSize: 13 }}
                >
                  {libelleModeleRapport}
                </span>
              );
            }}

            getOptionLabel={(modeleItem) =>
              `${modeleItem.libelleModeleRapport}`
            }

            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                size="small"
                label="Choisir un modèle de rapport"
              />
            )}
          />

          {/* <TextField
            fullWidth
            size="small"
            select
            label="Choisir un modèle"
            name="idModele"
            value={idModele}
            onChange={(e) => setIdModele(e.target.value)}
          >
            {modelesRapport.map((item: IModeleRapport, index: number) => (
              <MenuItem key={index} value={item.idModeleRapport} style={{ width: "100%" }}>
                {item.libelleModeleRapport}
              </MenuItem>
            ))}
          </TextField> */}
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            label="Titre"
            name="title"
            value={planItem?.title || ""}
            onChange={(e) => handleInputChange(e)}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            label="Name"
            name="name"
            value={planItem?.name || ""}
            onChange={(e) => handleInputChange(e)}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            multiline
            maxRows={4}
            size="small"
            label="Instructions"
            name="instructions"
            value={planItem?.instructions || ""}
            onChange={(e) => handleInputChange(e)}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            select
            label="Types de champs"
            name="type"
            value={planItem?.type || ""}
            onChange={(e) => handleInputChange(e)}
          >
            {types.map((item, index: number) => (
              <MenuItem key={index} value={item.idType}>
                {item.libelle}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            select
            label="Typographie"
            name="typographie"
            value={planItem?.typographie || ""}
            onChange={(e) => handleInputChange(e)}
          >
            {typographies.map((item, index: number) => (
              <MenuItem key={index} value={item.idTypographie}>
                {item.libelle}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {renderInputOption(planItem) &&
          <Grid item md={6} xs={12} sm={6}>
            {optionsData.map((item: IOptionData, index: number) => (
              <Grid container spacing={2} key={index}>
                <Grid item md={10} xs={10} sm={10}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Libellé de l'option"
                    name="libelleOption"
                    value={item?.libelleOption || ""}
                    onChange={(e) => handleOptionInputChange(e, index)}
                  />
                </Grid>
                <Grid style={{ marginTop: 10 }}>
                  <IconButton
                    onClick={() => handleOptionRowDelete(index)}
                  >
                    <DeleteIcon color="info" />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
            <Grid item md={12} xs={12} sm={12}>
              <IconButton
                onClick={onAddOptionRow}
              >
                <AddIcon color="info" />
              </IconButton>
            </Grid>
          </Grid>}

        <Grid item md={12} xs={12} sm={12}>
          <Divider />
        </Grid>

        <Grid item md={12} xs={12} sm={12}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Button
              size="small"
              variant="contained"
              // disabled
              onClick={mode === "add" ? handleAddItem : handleEditItem}
            >
              {mode === "add" ? "Ajouter" : "Modifier"}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
